import { useCallback, useEffect, useState } from "react";
import axios from "axios";
import { ScoreInfo } from "@/components/mai/Explain";
import { PageShell } from "@/components/mai/PageShell";
import { AssetManager } from "@/components/mai/AssetManager";
import { Heatmap } from "@/components/mai/Heatmap";
import { CorrectedAcceptance } from "@/components/mai/CorrectedAcceptance";
import { ArchivedAssets } from "@/components/mai/ArchiveManager";
import { useProduct } from "@/context/ProductContext";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function EvidencePage() {
  const { productId } = useProduct();
  const [data, setData] = useState(null);

  const load = useCallback(() => {
    axios.get(`${API}/reusability/${productId}`).then((r) => setData(r.data)).catch(console.error);
  }, [productId]);

  useEffect(() => { setData(null); load(); }, [load]);

  return (
    <PageShell pageId="reusability" overline="Evidence Intelligence Layer · Layer 6" title="Evidence Reuse Engine">
      {!data ? (
        <div data-testid="loading-state" className="py-32 text-center text-slate-400 text-sm">Computing reusability…</div>
      ) : (
        <>
          <section className="space-y-4">
            <div>
              <p className="overline-label text-slate-400">Acceptance Mapping</p>
              <h2 className="font-heading font-bold text-lg tracking-tight mt-1">Reusability Heatmap — Assets × Global Markets <ScoreInfo scoreId="reuse_score" /></h2>
              <p className="text-sm text-slate-500 mt-1">Click any cell for the acceptance rationale. Bucket fit chips: HTA = Formal HTA, CM = Cost-Minimisation, HP = Hospital/Payer.</p>
            </div>
            <Heatmap data={data} />
          </section>
          <AssetManager productId={productId} assets={data.assets} countries={data.countries} onChanged={load} />
          <CorrectedAcceptance productId={productId} />
          <ArchivedAssets productId={productId} onChanged={load} />
        </>
      )}
    </PageShell>
  );
}
